import { render, staticRenderFns } from "./NoInterestMarksContent.vue?vue&type=template&id=2f8a8c3e&scoped=true"
import script from "./NoInterestMarksContent.vue?vue&type=script&lang=js"
export * from "./NoInterestMarksContent.vue?vue&type=script&lang=js"
import style0 from "./NoInterestMarksContent.vue?vue&type=style&index=0&id=2f8a8c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a8c3e",
  null
  
)

export default component.exports